// Distinct standard, not HSK level zero. Uses the existing course contract.
export const INTRO_STANDARD='MANDARINO-INTRO';
export const isIntroCourse=(course:any)=>course?.hskLevel?.standardCode===INTRO_STANDARD;
export function introFrom(text:string):any|null{
 const m=/^\s*```(?:mandarino-intro-v1|mandarino-intro-page-v1)[ \t]*\r?\n([\s\S]+?)\r?\n```[ \t]*$/m.exec(text);
 if(!m)return null;
 try{const p=JSON.parse(m[1]);return p.schema==='mandarino-intro-page-v1'&&Array.isArray(p.nodes)?p:null;}catch{return null;}
}
